import React, {useEffect, useState} from 'react';
import styles from './BrazilianBracket.module.css';
import {
    checkIfResultsEntered,
    renderMatchResultForSingleElimination,
    renderPartnerName,
    renderPlayerName
} from "../../../utils";
import {getUserData} from "../../../api/api";
import {TfiAngleDoubleLeft, TfiAngleDoubleRight} from "react-icons/tfi";



const getProgressColor = (percentage) => {
    if (percentage === 100) return '#2196f3';
    if (percentage >= 67) return '#4caf50';
    if (percentage >= 34) return '#ffeb3b';
    return '#f44336';
};

const getCompletedMatchCount = (matches) => {
    return matches.filter(match => match.participantWinnerId !== null).length;
};



const BrazilianBracket = ({matches, onEditMatch, isArchived, onOpenH2H, tournamentStatus}) => {
    const [userData, setUserData] = useState({});
    const [currentRound, setCurrentRound] = useState(1);
    const [totalRounds, setTotalRounds] = useState(0); // Total rounds will be determined based on matches
    const [hoveredMatch, setHoveredMatch] = useState(null);




    const handleMouseEnter = (matchNumber) => {
        setHoveredMatch(matchNumber);
    };

    const handleMouseLeave = () => {
        setHoveredMatch(null);
    };

    const matchHighlightMap30 = {
        1: [1, 9, 16, 21, 27, 29],
        2: [2, 9, 16, 21, 27, 29],
        3: [3, 10, 15, 21, 27, 29],
        4: [4, 10, 15, 21, 27, 29],
        5: [5, 11, 14, 22, 28, 29],
        6: [6, 11, 14, 22, 28, 29],
        7: [7, 12, 13, 22, 28, 29],
        8: [8, 12, 13, 22, 28, 29],
        9: [9, 21, 17, 21, 27, 29],
        10: [10, 21, 18, 21, 27, 29],
        11: [11, 22, 19, 22, 28, 29],
        12: [12, 22, 20, 22, 28, 29],
        13: [13, 17, 23, 25, 27, 29],
        14: [14, 18, 23, 25, 27, 29],
        15: [15, 19, 24, 26, 28, 29],
        16: [16, 20, 24, 26, 28, 29],
        17: [17, 23, 25, 27, 29],
        18: [18, 23, 25, 27, 29],
        19: [19, 24, 26, 28, 29],
        20: [20, 24, 26, 28, 29],
        21: [21, 27, 26, 27, 29],
        22: [22, 28, 25, 28, 29],
        23: [23, 25, 27, 29],
        24: [24, 26, 28, 29],
        25: [25, 27, 29],
        26: [26, 28, 29],
        27: [27, 29, 30],
        28: [28, 29, 30]
    };

    const matchHighlightMap14 = {
        1: [1, 7, 5, 11, 13],
        2: [2, 7, 5, 11, 13],
        3: [3, 8, 6, 12, 13],
        4: [4, 8, 6, 12, 13],
        5: [5, 10, 11, 13],
        6: [6, 9, 12, 13],
        7: [7, 9, 11, 13],
        8: [8, 10, 12, 13],
        9: [9, 11, 13],
        10: [10, 12, 13],
        11: [11, 13, 14],
        12: [12, 13, 14]
    };

    // BRAZILIAN_FAST (TGPM) 16 graczy, 29 meczów. WB Final = #27, LB 5 runda = #28, Mecz o 2/3 = #29.
    // Przegrany #27 → #29 jako p2; zwycięzca #28 → #29 jako p1.
    const matchHighlightMap29 = {
        1: [1, 9, 16, 21, 27, 29],
        2: [2, 9, 16, 21, 27, 29],
        3: [3, 10, 15, 21, 27, 29],
        4: [4, 10, 15, 21, 27, 29],
        5: [5, 11, 14, 22, 27, 29],
        6: [6, 11, 14, 22, 27, 29],
        7: [7, 12, 13, 22, 27, 29],
        8: [8, 12, 13, 22, 27, 29],
        9: [9, 21, 27, 29],
        10: [10, 21, 27, 29],
        11: [11, 22, 27, 29],
        12: [12, 22, 27, 29],
        13: [13, 17, 23, 25, 28, 29],
        14: [14, 18, 23, 25, 28, 29],
        15: [15, 19, 24, 26, 28, 29],
        16: [16, 20, 24, 26, 28, 29],
        17: [17, 23, 25, 28, 29],
        18: [18, 23, 25, 28, 29],
        19: [19, 24, 26, 28, 29],
        20: [20, 24, 26, 28, 29],
        21: [21, 27, 26, 28, 29], // przegrany #21 → LB 4 runda #26
        22: [22, 27, 25, 28, 29], // przegrany #22 → LB 4 runda #25
        23: [23, 25, 28, 29],
        24: [24, 26, 28, 29],
        25: [25, 28, 29],
        26: [26, 28, 29],
        27: [27, 29], // przegrany WB Final → Mecz o 2/3 (#29)
        28: [28, 29], // zwycięzca LB 5 runda → Mecz o 2/3 (#29)
        29: [29]
    };

    // BRAZILIAN_FAST (TGPM): kopia matchHighlightMap14 bez referencji do meczów #13 (GF) i #14 (3rd).
    const matchHighlightMap12 = {
        1: [1, 7, 5, 11],
        2: [2, 7, 5, 11],
        3: [3, 8, 6, 12],
        4: [4, 8, 6, 12],
        5: [5, 10, 11],
        6: [6, 9, 12],
        7: [7, 9, 11],
        8: [8, 10, 12],
        9: [9, 11],
        10: [10, 12],
        11: [11],
        12: [12]
    };

    // BRAZILIAN_FAST 13 meczów (5-8 graczy, double-elim z Meczem o 2). Hover-highlight i tak
    // wyłączony dla isFast — placeholder dla spójności z dispatcherem currentMap.
    const matchHighlightMap13 = {
        1: [1], 2: [2], 3: [3], 4: [4],
        5: [5], 6: [6], 7: [7], 8: [8],
        9: [9], 10: [10], 11: [11], 12: [12], 13: [13]
    };


    useEffect(() => {
        const fetchData = async () => {
            const data = await getUserData();
            setUserData(data);
        };
        fetchData();
    }, []);


    useEffect(() => {
        // Ensure there are matches before proceeding
        if (matches.length === 0) {
            return; // Exit the effect if no matches have been loaded yet
        }

        const matchCount = matches.length;
        switch (matchCount) {
            case 30:
                setTotalRounds(4);
                break;
            case 29:
                // BRAZILIAN_FAST 16 graczy: WB 4 rundy, LB 6 rund. Carousel pokazuje 6.
                setTotalRounds(6);
                break;
            case 14:
                setTotalRounds(4);
                break;
            case 12:
                // BRAZILIAN_FAST 5–8 graczy (legacy 12-meczowa): WB i LB po 3 rundy.
                setTotalRounds(3);
                break;
            case 13:
                // BRAZILIAN_FAST 5–8 graczy: WB 3 rundy, LB 4 rundy. Carousel pokazuje 4.
                setTotalRounds(4);
                break;
            default:
                console.error("Unsupported number of matches");
        }
    }, [matches]);



    // Helper function to find match by number
    const findMatchByNumber = (number) => {
        return matches.find(match => match.matchNumber === number);
    };

    const canUserEditMatch = (match) => {
        // Check if the user is logged in and has the necessary role or is a participant of the match
        const userRoles = new Set(userData.authorities || []);
        const isUserAdminOrViewer = userRoles.has("ROLE_ADMIN") || userRoles.has("ROLE_SUPERVISOR");
        const isUserParticipant = match.userId1 === userData.id || match.userId2 === userData.id || match.userId1Partner === userData.id || match.userId2Partner === userData.id;

        return isUserAdminOrViewer || isUserParticipant;
    };


    // Function to go to the next round
    const goToNextRound = () => {
        setCurrentRound((prevRound) => (prevRound < totalRounds ? prevRound + 1 : prevRound));
    };

    // Function to go to the previous round
    const goToPreviousRound = () => {
        setCurrentRound((prevRound) => (prevRound > 1 ? prevRound - 1 : prevRound));
    };

    const renderMatchCell = (matchNumber) => {

    const matchCount = matches.length;
    let currentMap;
    if (matchCount === 14) currentMap = matchHighlightMap14;
    else if (matchCount === 13) currentMap = matchHighlightMap13;
    else if (matchCount === 12) currentMap = matchHighlightMap12;
    else if (matchCount === 29) currentMap = matchHighlightMap29;
    else currentMap = matchHighlightMap30;


    const match = findMatchByNumber(matchNumber);
    // BRAZILIAN_FAST (matchCount 29/13/12): bez hover-highlight — mapa awansów jest gęsta
    // i podświetlanie utrudnia odczyt drabinki. Klasyk BRAZILIAN (30/14) zachowuje highlight.
    const isFast = matchCount === 29 || matchCount === 13 || matchCount === 12;
    const isHighlighted = !isFast && hoveredMatch && currentMap[hoveredMatch]?.includes(matchNumber);
    const hasParticipants = match && (match.participant1Id && match.participant2Id);


        return (
        <div className={styles.matchSlot} key={matchNumber}>
            <div
                className={`${styles.matchCell} ${isHighlighted ? styles.highlighted : ''}`}
                onMouseEnter={isFast ? undefined : () => handleMouseEnter(matchNumber)}
                onMouseLeave={isFast ? undefined : handleMouseLeave}
            >
                {match && tournamentStatus === 'ACTIVE' && match.playOrder && (
                    <div className={styles.playOrderBadge} title={`Mecz nr ${match.playOrder} w kolejności rozgrywania`}>
                        {match.playOrder}
                    </div>
                )}
                {match ? (
                    <>
                        <div className={styles.playerNames}>
                            {match.participant1Id ?
                                <div>
                                    {renderPlayerName(match.participant1Id, match.participant1LastName, match.participant1FirstName, match, match.seedNumberParticipant1)}
                                    {match.participant1PartnerLastName && (
                                        <>
                                            <br/>
                                            <span
                                                className={styles.partnerName}>{renderPartnerName(match.participant1Id, match.participant1PartnerLastName, match.participant1PartnerFirstName, match)}</span>
                                        </>
                                    )}
                                </div> : <div>&nbsp;</div>}
                            {match.participant2Id ?
                                <div>
                                    {renderPlayerName(match.participant2Id, match.participant2LastName, match.participant2FirstName, match, match.seedNumberParticipant2)}
                                    {match.participant2PartnerLastName && (
                                        <>
                                            <br/>
                                            <span
                                                className={styles.partnerName}>{renderPartnerName(match.participant2Id, match.participant2PartnerLastName, match.participant2PartnerFirstName, match)}</span>
                                        </>
                                    )}
                                </div> :
                                <div>&nbsp;</div>}
                        </div>
                            {match.skipRematch ? (
                                <div className={styles.skipLabel} title="Mecz pominięty regulaminowo — zawodnicy już raz grali w tym turnieju">(bez gry)</div>
                            ) : (
                                match.setResults && renderMatchResultForSingleElimination(match.setResults)
                            )}
                        <div className={styles.actions}>
                             {!isArchived && hasParticipants && !match.skipRematch && !checkIfResultsEntered(match) && (
                                 <button
                                   className={styles.button}
                                   onClick={() => onOpenH2H && onOpenH2H(match.id)}
                                   aria-label="Head to Head"
                                 >
                                   H2H
                                 </button>
                             )}
                            {!isArchived && hasParticipants && !match.skipRematch && canUserEditMatch(match) && (
                                <button className={styles.button} onClick={() => onEditMatch(match.id)}>
                                    {checkIfResultsEntered(match) ? 'Edytuj' : 'Dodaj'}
                                </button>
                            )}
                        </div>
                    </>
                ) : (
                    `match ${matchNumber}`
                )}
            </div>
        </div>
        );
    };



    const renderProgressBar = () => {
        // Dla turniejów ze przypisanym `playOrder` (BRAZILIAN klasyk i BRAZILIAN_FAST od 2026-05)
        // mianownikiem są tylko mecze realnie rozgrywane — bye'e i miejsca w drabince poza
        // ścieżką gracza dostają playOrder=NULL i są pomijane. Dla starych turniejów
        // (przed wdrożeniem playOrder dla klasyka) playOrder zawsze NULL — fallback na `matches.length`.
        const hasPlayOrder = matches.some(m => m.playOrder != null);
        const playableMatches = hasPlayOrder
            ? matches.filter(m => m.playOrder != null)
            : matches;
        const totalExpectedMatches = playableMatches.length;
        const completedMatches = getCompletedMatchCount(playableMatches);
        const progressPercentage = totalExpectedMatches > 0 ? Math.round((completedMatches / totalExpectedMatches) * 100) : 0;

        return (
            <div className={styles.progressWrapper}>
                <div className={styles.progressBar}>
                    <div
                        className={styles.progressFill}
                        style={{
                            width: `${progressPercentage}%`,
                            backgroundColor: getProgressColor(progressPercentage),
                        }}
                    ></div>
                </div>
                <div className={styles.progressText}>
                    {progressPercentage} % rozegranych ({completedMatches}/{totalExpectedMatches})
                </div>
            </div>
        );
    };




    const renderRoundTitle = (roundName, roundNumber) => (
        <div>
            <h5 className={styles.titleOfRound}>
                {currentRound > 1 && roundNumber === currentRound && (
                    <button className={styles.navigationButton} onClick={goToPreviousRound}>
                        <TfiAngleDoubleLeft/>
                    </button>
                )}
                {roundName}
                {currentRound < totalRounds && roundNumber === currentRound && (
                    <button className={styles.navigationButton} onClick={goToNextRound}>
                        <TfiAngleDoubleRight/>
                    </button>
                )}
            </h5>
        </div>
    );


    const renderRound = (roundName, roundNumber, matchesNumbers, extraClass = '', rowSpan = 1) => (
        <div
            className={`${styles.round} ${styles[`round${roundNumber}`]} ${extraClass} ${currentRound === roundNumber ? styles.current : ''}`}
            style={{ '--row-span': rowSpan }}>
            {renderRoundTitle(roundName, roundNumber)}
            {matchesNumbers.map(renderMatchCell)}
        </div>
    );

    const generateBracket = () => {
        const matchCount = matches.length;
        switch (matchCount) {
            case 30:
                return (
                    <div className={styles.bracketContainer}>
                        <div className={styles.finalRounds}>
                            {renderRound('1 runda', 1, [1, 2, 3, 4, 5, 6, 7, 8])}
                            {renderRound('Druga szansa', 1, [13, 14, 15, 16])}
                        </div>
                        <div className={styles.finalRounds}>
                            {renderRound('2 runda', 2, [9, 10, 11, 12])}
                            {renderRound('Druga szansa', 2, [17, 18, 19, 20])}
                        </div>
                        <div className={styles.finalRounds}>
                            {renderRound('Ćwierćfinały', 3, [21, 22])}
                            {renderRound('Druga szansa', 3, [25, 26, 23, 24])}
                        </div>
                        <div className={styles.finalRounds}>
                            {renderRound('Półfinały', 4, [27, 28])}
                            {renderRound('Mecz o 3 miejsce', 4, [30])}
                            {renderRound('Finał', 4, [29])}
                        </div>
                    </div>
                );
            case 14:
                return (
                    <div className={styles.bracketContainer}>
                        <div className={styles.finalRounds}>
                            {renderRound('1 runda', 1, [1, 2, 3, 4])}
                            {renderRound('Druga szansa', 1, [7, 8])}
                        </div>
                        <div className={styles.finalRounds}>
                            {renderRound('2 runda', 2, [5, 6])}
                            {renderRound('Druga szansa', 2, [9, 10])}
                        </div>
                        {renderRound('Półfinały', 3, [11, 12])}
                        <div className={styles.finalRounds}>
                            {renderRound('Mecz o 3 miejsce', 4, [14])}
                            {renderRound('Finał', 4, [13])}
                        </div>
                    </div>
                );
            case 29:
                // BRAZILIAN_FAST (TGPM) — 16 graczy, 29 meczów. Dwie równoległe drabinki:
                // górna (8/4/2/1 — 4 rundy, max 8 wierszy gridu),
                // dolna (4/4/2/2/1/1 — 6 rund, max 4 wiersze gridu, 1-do-1: R1→R2, R3→R4, R5→R6).
                return (
                    <div className={styles.fastBracketWrapper}>
                        <div className={styles.bracketSection}>
                            <h4 className={styles.bracketSectionTitle}>Górna drabinka — o I miejsce</h4>
                            <div className={`${styles.bracketContainer} ${styles.fastBracket}`}
                                 style={{'--bracket-rows': 8}}>
                                {renderRound('1 runda', 1, [1, 2, 3, 4, 5, 6, 7, 8], '', 1)}
                                {renderRound('Ćwierćfinał', 2, [9, 10, 11, 12], '', 2)}
                                {renderRound('Półfinał', 3, [21, 22], '', 4)}
                                {renderRound('Finał (I miejsce)', 4, [27], '', 8)}
                            </div>
                        </div>
                        <div className={styles.bracketSection}>
                            <h4 className={`${styles.bracketSectionTitle} ${styles.lowerBracketTitle}`}>Dolna drabinka — o II / III miejsce</h4>
                            <div className={`${styles.bracketContainer} ${styles.fastBracket} ${styles.lowerBracket}`}
                                 style={{'--bracket-rows': 4}}>
                                {renderRound('1 runda', 1, [13, 14, 15, 16], styles.straightConnect, 1)}
                                {renderRound('2 runda', 2, [17, 18, 19, 20], '', 1)}
                                {renderRound('3 runda', 3, [23, 24], styles.straightConnect, 2)}
                                {renderRound('4 runda', 4, [25, 26], '', 2)}
                                {renderRound('5 runda', 5, [28], styles.straightConnect, 4)}
                                {renderRound('Mecz o 2 miejsce', 6, [29], '', 4)}
                            </div>
                        </div>
                    </div>
                );
            case 12:
                // BRAZILIAN_FAST (legacy 12-meczowa, 5–8 graczy). Czyste 2 drabinki bez Mecza o 2
                // z WB Final loserem. Zachowane dla starych turniejów.
                return (
                    <div className={styles.fastBracketWrapper}>
                        <div className={styles.bracketSection}>
                            <h4 className={styles.bracketSectionTitle}>Górna drabinka — o I miejsce</h4>
                            <div className={`${styles.bracketContainer} ${styles.fastBracket}`}
                                 style={{'--bracket-rows': 4}}>
                                {renderRound('1 runda', 1, [1, 2, 3, 4], '', 1)}
                                {renderRound('Półfinał', 2, [5, 6], '', 2)}
                                {renderRound('Finał (I miejsce)', 3, [11], '', 4)}
                            </div>
                        </div>
                        <div className={styles.bracketSection}>
                            <h4 className={`${styles.bracketSectionTitle} ${styles.lowerBracketTitle}`}>Dolna drabinka — o II / III miejsce</h4>
                            <div className={`${styles.bracketContainer} ${styles.fastBracket} ${styles.lowerBracket}`}
                                 style={{'--bracket-rows': 2}}>
                                {renderRound('1 runda', 1, [7, 8], styles.straightConnect, 1)}
                                {renderRound('Półfinał', 2, [9, 10], '', 1)}
                                {renderRound('Mecz o 2 miejsce', 3, [12], '', 2)}
                            </div>
                        </div>
                    </div>
                );
            case 13:
                // BRAZILIAN_FAST (TGPM) — 5–8 graczy, 13 meczów. Pełen double-elim z Meczem o 2:
                // górna (4/2/1 — 3 rundy, max 4 wiersze gridu),
                // dolna (2/2/1/1 — 4 rundy, max 2 wiersze gridu; R1→R2 1-do-1, R3→Mecz o 2 1-do-1).
                return (
                    <div className={styles.fastBracketWrapper}>
                        <div className={styles.bracketSection}>
                            <h4 className={styles.bracketSectionTitle}>Górna drabinka — o I miejsce</h4>
                            <div className={`${styles.bracketContainer} ${styles.fastBracket}`}
                                 style={{'--bracket-rows': 4}}>
                                {renderRound('1 runda', 1, [1, 2, 3, 4], '', 1)}
                                {renderRound('Półfinał', 2, [5, 6], '', 2)}
                                {renderRound('Finał (I miejsce)', 3, [12], '', 4)}
                            </div>
                        </div>
                        <div className={styles.bracketSection}>
                            <h4 className={`${styles.bracketSectionTitle} ${styles.lowerBracketTitle}`}>Dolna drabinka — o II / III miejsce</h4>
                            <div className={`${styles.bracketContainer} ${styles.fastBracket} ${styles.lowerBracket}`}
                                 style={{'--bracket-rows': 2}}>
                                {renderRound('1 runda', 1, [7, 8], styles.straightConnect, 1)}
                                {renderRound('2 runda', 2, [9, 10], '', 1)}
                                {renderRound('3 runda', 3, [11], styles.straightConnect, 2)}
                                {renderRound('Mecz o 2 miejsce', 4, [13], '', 2)}
                            </div>
                        </div>
                    </div>
                );
            default:
                return <div>Unsupported number of matches</div>;
        }
    };


    return <>
        {!isArchived && renderProgressBar()}
        {generateBracket()}
    </>
};

export default BrazilianBracket;
